import React from "react";
import { useForm } from "react-hook-form";
import { useState, useEffect } from "react";
import { contentful } from "../utils/contentful";
import { useNavigate } from "@reach/router";
import styled from "styled-components";
import { tablet } from "../responsive";
import insightful from "../assets/insightful.svg";
import { FormButton } from "../components/Buttons";
const StyledLogin = styled.div`
  position: relative;
  .logo-wrapper {
    position: absolute;
    content: "";
    transform: translateX(-50%);
    left: 50%;
    top: -80px;
  }

  .insightful {
    height: 4rem;
  }
`;
const StyledLoginBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  form {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 2rem;
    row-gap: 1rem;
    width: 50vh;
    height: 50vh;
    ${tablet({ height: "30vh", width: "30vh" })}
    min-width: 320px;
    min-height: 320px;
    background-color: white;
    box-shadow: 0px 0px 10px 1px #666666;
  }
  h1 {
    font-size: 1.2rem;
    text-align: center;
  }

  h2 {
    font-weight: 300;
    font-size: 0.9rem;
  }
  input,
  select {
    width: 17rem;
    height: 2rem;
  }
`;

function Login({ setLoggedIn }) {
  const [clubs, setClubs] = useState([]);
  const [invalidPassword, setInvalidPassword] = useState(false);
  const { register, handleSubmit } = useForm();
  const navigate = useNavigate();

  const onSubmit = ({ club, password, fullName }) => {
    setInvalidPassword(false);
    clubs.forEach((v) => {
      const myStorage = window.localStorage;
      if (password === v.password && club === v.clubName) {
        myStorage.setItem("loggedIn", "true");
        myStorage.setItem("club", club);
        setLoggedIn(true);
        navigate(`/`, { state: { club: club, loggedIn: true } });
      } else setInvalidPassword(true);
    });
  };

  useEffect(() => {
    contentful("clubs").then(({ data, errors }) => {
      if (errors) {
        console.error(errors);
      }
      setClubs(data.newAndClubCollection.items);
    });
  }, []);

  return (
    <StyledLogin>
      <div className="logo-wrapper">
        <img className="insightful" src={insightful} alt="Insightful" />
      </div>
      <StyledLoginBox>
        <form onSubmit={handleSubmit(onSubmit)}>
          <h1>Welcome to the Insights Dashboard</h1>
          <h2>Login below to access</h2>
          <select {...register("club", { required: true })}>
            <option value="" selected="selected" hidden="hidden">
              Select Club{" "}
            </option>
            {clubs.map((club) => {
              return (
                <option key={club.clubName} value={club.clubName}>
                  {club.clubName}
                </option>
              );
            })}
          </select>
          <input
            type="password"
            {...register("password", { required: true })}
            placeholder="Password"
          />
          <FormButton value="Access Dashboard" right="10px" />
          {invalidPassword && <div>Invalid Password, please try again</div>}
        </form>
      </StyledLoginBox>
    </StyledLogin>
  );
}

export default Login;
